var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 21,
    viewBox: "0 0 33 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54572 4.2732C12.7616 -0.8313 21.218 -0.8313 26.4339 4.2732L27.0616 4.88751C27.3224 5.14277 27.3224 5.55654 27.0616 5.8118L24.9143 7.9133C24.7839 8.04093 24.5725 8.04093 24.442 7.9133L23.5782 7.06794C19.9396 3.50688 14.04 3.50688 10.4014 7.06794L9.4763 7.97324C9.34593 8.10087 9.13446 8.10087 9.00409 7.97324L6.85671 5.87174C6.59596 5.61648 6.59596 5.20271 6.85671 4.94745L7.54572 4.2732ZM30.8748 8.61938L32.7859 10.4897C33.0468 10.7449 33.0468 11.1587 32.7859 11.414L24.1685 19.8477C23.9077 20.1029 23.4849 20.1029 23.224 19.8477L17.1079 13.862C17.0427 13.7982 16.937 13.7982 16.8718 13.862L10.7558 19.8477C10.495 20.1029 10.0722 20.1029 9.8114 19.8477L1.19364 11.4139C0.932849 11.1586 0.932849 10.7449 1.19364 10.4896L3.10479 8.61929C3.36557 8.36403 3.7884 8.36403 4.0492 8.61929L10.1655 14.6049C10.2307 14.6688 10.3363 14.6688 10.4015 14.6049L16.5175 8.61929C16.7783 8.36403 17.2011 8.36404 17.4619 8.61921L23.5781 14.6049C23.6434 14.6688 23.749 14.6688 23.8142 14.6049L29.9304 8.61938C30.1912 8.36412 30.614 8.36412 30.8748 8.61938Z",
    fill: "#3396FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/WalletConnect.52bcff4692ffd89734aeced143c89250.svg";
export { ForwardRef as ReactComponent };